export const getPath = (params: Record<string, string | number>, path: string) =>
  Object.keys(params).reduce(
    (transformedPath, paramKey) =>
      transformedPath.replace(`:${paramKey}`, params[paramKey].toString()),
    path
  );
